import styled from 'styled-components'

const SurveyAnswerTextUi = styled.div`
  width: calc(100% - 25px);
`

export default SurveyAnswerTextUi
